"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountBalance = void 0;
var account_1 = require("../account");
var enums_1 = require("./enums");
/** Баланс пользователя */
var AccountBalance = /** @class */function () {
  function AccountBalance(values) {
    if (values === void 0) {
      values = {};
    }
    var properties = ['id', 'account_id', 'currency_id', 'type', 'amount', 'changed_at'];
    var instance = this;
    properties.forEach(function (p) {
      if (p in values) {
        instance[p] = values[p];
      }
    });
    instance.changed_at = values.changed_at instanceof Date ? values.changed_at : new Date(values.changed_at);
    instance.currency = account_1.currencies[values.currency_id];
  }
  AccountBalance.getAvailableValue = function (accountBalanceInfo) {
    var plusBalance = [enums_1.AccountBalanceTypeEnum.paid, enums_1.AccountBalanceTypeEnum.gifts, enums_1.AccountBalanceTypeEnum.coupons, enums_1.AccountBalanceTypeEnum.plan_grants];
    var minusBalance = [enums_1.AccountBalanceTypeEnum.hold];
    var result = 0;
    for (var _i = 0, _a = Object.keys(accountBalanceInfo); _i < _a.length; _i++) {
      var balanceTypeKey = _a[_i];
      var balanceType = parseInt(balanceTypeKey, 10);
      var modifier = 0;
      if (plusBalance.includes(balanceType)) {
        modifier = 1;
      } else if (minusBalance.includes(balanceType)) {
        modifier = -1;
      }
      result += accountBalanceInfo[balanceType] * modifier;
    }
    return result;
  };
  return AccountBalance;
}();
exports.AccountBalance = AccountBalance;
